import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getWaterfallAnalyses,
  getWaterfallAnalysis,
  createWaterfallAnalysis,
  clearLocalWaterfallAnalyses,
  clearLocalActiveWaterfallAnalysis
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  waterfallAnalysis: { 
    id: '', 
    input: null, 
    first_result: null, 
    second_result: null, 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    waterfallAnalysis: false 
  }
};

const slice = createSlice({
  name: 'waterfallAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getWaterfallAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getWaterfallAnalyses.fulfilled, (state, action) => {
        const { waterfall_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...waterfall_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getWaterfallAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getWaterfallAnalysis.pending, (state) => {
        state.loading.waterfallAnalysis = true;
      })
      .addCase(getWaterfallAnalysis.fulfilled, (state, action) => {
        const { data: { waterfall_analysis }, cable } = action.payload;
        const foundedWaterfallAnalysis = !!_find(state.all.data, (s) => s.id === waterfall_analysis.id);
        const updatedWaterfallAnalysis = { ...state.waterfallAnalysis, ...waterfall_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedWaterfallAnalysis ? _map(state.all.data, (e) => e.id === waterfall_analysis.id ? { ...e, ...waterfall_analysis } : e) : [...[waterfall_analysis], ...oldAllData]; 
        const pagination = foundedWaterfallAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.waterfallAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedWaterfallAnalysis && !cable) state.waterfallAnalysis = updatedWaterfallAnalysis;       
      })
      .addCase(getWaterfallAnalysis.rejected, (state) => {
        state.loading.waterfallAnalysis = false;
      })
      .addCase(createWaterfallAnalysis.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(createWaterfallAnalysis.fulfilled, (state, action) => {
        const { waterfall_analysis } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[waterfall_analysis], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.all = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.waterfallAnalysis = waterfall_analysis;  
      })
      .addCase(createWaterfallAnalysis.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(clearLocalWaterfallAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveWaterfallAnalysis, state => {
        state.waterfallAnalysis = initialState.waterfallAnalysis;
      })
  }
})

export default slice.reducer;